"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordResetLink = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var PasswordResetLink = function () {
    var clickHandler = function () {
        location.href = "/password/reset";
    };
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: { textAlign: "right" }, children: (0, jsx_runtime_1.jsx)("a", { onClick: clickHandler, style: {
                color: "#3B91D1",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
            }, children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u3067\u3059\u304B\uFF1F" }) }));
};
exports.PasswordResetLink = PasswordResetLink;
